module.exports = __webpack_public_path__ + "img/PublicAccounts.be7d0023.png";